import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { base_url, postHeader } from '../Helpers/request';
import { useHistory } from "react-router-dom";
import Loader from './Loader';
import { Modal } from 'react-bootstrap';
import swal from 'sweetalert';
import { useDispatch } from 'react-redux';
import { cartlengthvalue } from '../Reducer/cartReducer';

export default function Squareup(props) {
  const history = useHistory();
const [loader,setLoader] = useState(false);
const dispatch = useDispatch()
  async function CardPay(fieldEl, buttonEl) {
    // Create a card payment object and attach to page
    const card = await window.payments.card({
      style: {
        '.input-container.is-focus': {
          borderColor: '#006AFF'
        },
        '.message-text.is-error': {
          color: '#BF0020'
        }
      }
    });
    await card.attach(fieldEl);

    async function eventHandler(event) {
      // Clear any existing messages
      // window.paymentFlowMessageEl.innerText = '';

      try {
        const result = await card.tokenize();
        if (result.status === 'OK') {
          // Use global method from sq-payment-flow.js
          window.createPayment(result.token);
        }
      } catch (e) {
        if (e.message) {
          window.showError(`Error: ${e.message}`);
        } else {
          window.showError('Something went wrong');
        }
      }
    }

    buttonEl.addEventListener('click', eventHandler);
  }

  const SquarePaymentFlow = async () => {

    // Create card payment object and attach to page
    CardPay(document.getElementById('card-container'), document.getElementById('card-button'));

    // Create Apple pay instance
    // Create Google pay instance
    // Create ACH payment
  }

  window.payments = window.Square.payments(window.applicationId, window.locationId);

  window.paymentFlowMessageEl = document.getElementById('payment-flow-message');

  window.showSuccess = function (message) {
    window.paymentFlowMessageEl.classList.add('success');
    window.paymentFlowMessageEl.classList.remove('error');
    window.paymentFlowMessageEl.innerText = message;
  }

  window.showError = function (message) {
    window.paymentFlowMessageEl.classList.add('error');
    window.paymentFlowMessageEl.classList.remove('success');
    window.paymentFlowMessageEl.innerText = message;
  }

  window.createPayment = async function (token) {
    const dataJsonString = JSON.stringify({
      token,
      order_id:props.data.order_id
    });

    try {
      // const response = await fetch('process-payment.php', {
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/json'
      //   },
      //   body: dataJsonString
      // });

      // const data = await response.json();

      // if (data.errors && data.errors.length > 0) {
      //   if (data.errors[0].detail) {
      //     window.showError(data.errors[0].detail);
      //   } else {
      //     window.showError('Payment Failed.');
      //   }
      // } else {
      //   window.showSuccess('Payment Successful!');
      //   history.push(`/ordersuccess/${response.data.data.order_id}/${response.data.data.order_no}/${response.data.data.txn_id}`)
      //   localStorage.removeItem("rcs-addtocartlength")
      //   sessionStorage.removeItem("rcs-checkoutdata")
      // }
      axios.post(base_url + '/order/square_pay', dataJsonString, {
        headers: postHeader
    })
        .then(response => {
            if (response.data.status == 1) {
                setLoader(false);
                dispatch(cartlengthvalue(0))
                sessionStorage.removeItem("dfl-checkoutdata")
                history.push(`/ordersuccess/${response.data.data.order_id}/${response.data.data.order_no}/${response.data.data.txn_id}`)
            } else {
              setLoader(false);
              return swal(response.data.message[0]?.category,"", "error");
            }
        })
        .catch(err => {
            console.log(err);
            setLoader(false);
        })
    } catch (error) {
      console.error('Error:', error);
    }
  }
 
  useEffect(() => {
    SquarePaymentFlow();
  }, [])

  // if(loader){
  //   return <Loader />
  // }

  return (
    <>
      <h2 className='mb-2'>Enter Card Details</h2>
      <form className="payment-form" id="fast-checkout">
        <div className="wrapper">
          <div id="card-container"></div><button className="rcs_square_pay_btn rcs_fill_button rcs_btn_rd-0 btn btn-primary" id="card-button" onClick={()=>setLoader(true)} type="button">Pay Now</button>
          <span id="payment-flow-message"></span>
        </div>
      </form>
      <Modal show={loader} >
      <Loader /> 
      </Modal>
    </>
  )
}
